import {
  Box,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  VStack,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";

export default function Features() {
  return (
    <Box
      bg="rgba(248, 249, 250, 1)"
      p={8}
      borderRadius="lg"
      shadow="md"
      marginBottom="168px"
      w={{ sm: "90%", "2xl": "50%" }}
      marginLeft="auto"
      marginRight="auto"
    >
      <VStack spacing={6} align="start">
        <Heading as="h2" size="lg" color="#C9342D">
          Korak po korak vodič do željene konfiguracije
        </Heading>
        <Text fontSize="md" color="gray.700">
          Našim klijentima nudimo različite opcije i funkcije za prilagođavanje
          samostalnog e-učenja. Svaki modul ili sekcija može biti optimizovana
          prema željama kupaca. Dostupne su automatske pozivnice kao i
          automatske poruke koje podsećaju korisnike o napretku i trenutnom
          statusu. Platforma je dostupna 24 sata, 7 dana u nedelji.
        </Text>

        <Text fontWeight="bold" fontSize="lg" color="#C9342D">
          Moduli za e-učenje se mogu prilagoditi na vaš korporativni identitet:
        </Text>

        <List spacing={3}>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Svest i osnove sajber bezbednosti
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Zaštita ličnih podataka
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Zaštita podataka i privatnost
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Bezbednost na Internetu
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Bezbednost e-maila
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Bezbedne lozinke
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Maliciozni softver
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Informaciona bezbednost u pokretu
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Ponašanje u slučaju incidenata
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Internet i onlajn alati
          </ListItem>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color="#c9342d" />
            Bezbednost u kancelariji
          </ListItem>
        </List>
      </VStack>
    </Box>
  );
}
